import type { McpServer } from "./types";

export const filterGatewaysBySearch = (gateways: McpServer[], term: string) => {
  const normalized = term.trim().toLowerCase();
  if (!normalized) {
    return gateways;
  }
  return gateways.filter((g) => {
    const values = [g.name, g.slug, g.description ?? ""];
    return values.some((v) => (v ?? "").toLowerCase().includes(normalized));
  });
};

export const groupGatewaysByBinding = (gateways: McpServer[]) =>
  ({
    project: gateways.filter((g) => g.binding.type === "project"),
    tenant: gateways.filter((g) => g.binding.type === "tenant"),
    static: gateways.filter((g) => g.binding.type === "static"),
  }) as const;
